// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

// Define a service using a base URL and expected endpoints
export const aboContactCardDetailsAPI = createApi({
  reducerPath: "aboContactCardDetailsAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getAboContactCardDetails: builder.query<any, UserSpecificArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/contacts`,
        method: "GET",
      })
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAboContactCardDetailsQuery } = aboContactCardDetailsAPI;
